import { contents } from ".."
import SkillItem from "../../components/SkillItem"

const QbTpnrpLuckyWheel = () => {
    const filteredProjects = contents.filter((item) => item.slug === 'qb-tpnrp-lucky-wheel')
    const project = filteredProjects[0]

    return (
        <div className="overflow-hidden bg-white py-24 sm:py-32 rounded-md">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                    <div className="lg:pr-8 lg:pt-4">
                        <div className="lg:max-w-lg">
                            <h2 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">TPNRP Lucky Wheel for QBCore</h2>
                            <div className="my-4">
                                {project.techStack.map((item, index: number) => {
                                    return (
                                        <SkillItem key={`landl-index-${index}-${item}`} label={item} />
                                    )
                                })}
                            </div>
                            <p className="mt-6 text-lg leading-8 text-gray-600 text-justify">
                            TPNRP Lucky Wheel is a script for QBCore servers. Players can spin the wheel at the Diamond Casino to win prizes.
                            </p>
                            <p className="mt-6 text-lg leading-8 text-gray-600 text-justify">
                            I built the script with Lua for FiveM. Server owners can change the spin cost and prizes in the settings.
                            </p>
                            
                            <br />
                            <div>
                                <img
                                    src={require('../../assets/projects/qb-tpnrp-lucky-wheel/qb-tpnrp-lucky-wheel-1.png')}
                                    alt="Lucky Wheel"
                                    className="rounded-xl shadow-xl ring-1 ring-gray-400/10"
                                    width={1920}
                                    height={1080}
                                />
                            </div>
                            <br />
                            <div>
                                
                            </div>
                        </div>
                    </div>
                    <div className="lg:pt-4">
                        <iframe 
                            width="560" 
                            height="315"
                            src="https://www.youtube.com/embed/1dXloRK-c_0?si=n1me1xj54XF13Qg6"
                            title="TPNRP Lucky Wheel demo"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            style={{
                                maxWidth: 560,
                                width: '100%',
                            }}
                            allowFullScreen></iframe>
                        <br />
                        <p className="mt-6 text-lg leading-8 text-gray-600 text-justify">
                            <h3 className="text-lg font-bold">Features:</h3>
                            <ul className="list-disc list-inside">
                                <li>
                                    <b>Player turns</b><br />
                                    {' '}You can set the wheel so only one player can spin at a time. Other players wait for their turn.
                                </li>
                                <li>
                                    <b>Prize display</b><br />
                                    {' '}A T20 car is shown in the prize display.
                                </li>
                                <li>
                                    <b>Spin cost and prizes</b><br />
                                    {' '}You can change the prizes and the cost of each spin. The default cost is $500.
                                </li>
                            </ul>
                        </p>
                        <br />
                        <b>GitHub:</b> <a href="https://github.com/Sn0wBiT/qb-tpnrp-lucky-wheel" target="_blank" rel="noreferrer">https://github.com/Sn0wBiT/qb-tpnrp-lucky-wheel</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default QbTpnrpLuckyWheel
